import modules from 'modules'
import ApiInstance from 'services/api'
import { push, replace, } from 'react-router-redux'

let apiCalls = []
let refreshingToken = false

const AuthActions = modules.actions.auth

export const interceptorMiddleware = (api) => {
  let interceptorsBinded = false

  return store => next => async action => {
    // first check tha is loged in
    // if (action.type === StartupActionTypes.STARTUP_FINISHED) {
    //   const { auth, user, } = store.getState()
    //   if (!auth.token) {
    //     tokenValid = true
    //   }
    // }

    if (!interceptorsBinded) {
      interceptorsBinded = true
      api.axiosInstance.interceptors.response.use((response) => { 
        return response
      }, async error => {
        let errorResponse = error.response
        const config = error.config
        const originalRequest = config

        if (errorResponse) {
          if (errorResponse.status === 401 && (errorResponse.data.path && errorResponse.data.path.indexOf('authenticate') === -1)) {
            const { auth, } = store.getState()
            if (!refreshingToken) {
              refreshingToken = true
              ApiInstance.auth.refreshToken(auth.token, auth.refreshToken).then(responseToken => {
                if (responseToken.ok) {
                  store.dispatch(AuthActions.updateToken({
                    token: responseToken.data.id_token,
                    refreshToken: responseToken.data.refresh_token
                  }))
                  refreshingToken = false
                  apiCalls.filter(apiCall => apiCall(responseToken.data.data.attributes.id_token))
                }
              })
            } else if (errorResponse.data.path && errorResponse.data.path.indexOf('token-refresh')){
              //The call that fails is the one to refresh the token
              store.dispatch(AuthActions.signout())
              window.location.href = 'auth'
            }
        
            const retryRequest = new Promise((resolve) => {
              apiCalls.push((token) => {
                originalRequest.headers.Authorization = 'Bearer ' + token
                resolve(api(originalRequest))
              })
            })
            return retryRequest
          }

          if (errorResponse.status === 403) {
            store.dispatch(AuthActions.signout())
            window.location.href = 'auth'
          }

          return Promise.reject(error)
        }
        return Promise.reject(error)
      })
    }

    next(action)
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/InterceptorMiddleware.js